export const viewTitle = "Окончание сроков хранения ЭАД";
export const viewUniqKey = "eadStoragePeriodReportView";
